export default "__VITE_ASSET__CSmXv4lG__"